
import Cookies from 'js-cookie';
import { formatDistance } from 'date-fns';
import { enUS, th } from 'date-fns/locale'

export const distance = (value) => {
  let option = {
    addSuffix: true,
    locale: enUS
  };
  if (Cookies.get('local') == 'th') {
    option = {
      addSuffix: true,
      locale: th
    };
  }

  return formatDistance(value, new Date(), option);
}
